import { Modal, ModalBody, ModalFooter, Button, Form, Select } from "@gpstrackit/react-controls";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState, useRef } from "react";
import { useIntl } from "react-intl";

//Controls
import { NotificationManager } from 'Components/Notifications';
import { Checkbox, Tabs, TabContainer } from "@gpstrackit/react-controls";
import { Alert, AlertTitle } from '@mui/material';
import CustomSelect from 'Components/Select';

import {
    Icon,
    OutlinedInput,
    InputAdornment,
    FormControl,
} from '@mui/material';

//Actions
import { getAccounts } from 'Modules/activities/views/main/redux/saga';
import {
    clearRedux,
    accountsImportSearchAccountRequest,
    accountsGetStatusRequest,
    accountsImportRequest,
    accountsGetAccountByPxRequest,
} from 'Redux/actions';

//Styles
import './index.scss';
const NewMigration = (props) => {
    const { getData } = props
    const { messages } = useIntl()
    const dispatch = useDispatch()
    const formRef = useRef(null);
    const [tab, setTab] = useState(0)
    const [openSearch, setOpenSearch] = useState("")
    const [externalAccount, setExternalAccount] = useState(null)
    const [noSearch, setNoSearch] = useState(false)
    const [internalAccount, setInternalAccount] = useState(null)
    const [newInternalAccount, setNewInternalAccount] = useState(null)
    const [server, setServer] = useState(null);

    //Entities Migration
    const [accounts, setAccounts] = useState(true)
    const [contacts, setContacts] = useState(false)
    const [categories, setCategories] = useState(false)
    const [behavior, setBehavior] = useState(false)
    const [users, setUsers] = useState(false)
    const [devices, setDevices] = useState(false)
    const [geofences, setGeofences] = useState(false)
    const [maintenance, setMaintenance] = useState(false)
    const [drivers, setDrivers] = useState(false)
    const [alerts, setAlerts] = useState(false)
    const [speedOverrides, setSpeedOverrides] = useState(false)

    //Redux Store
    const {
        accountsList,
        loading,
        openModal,
        result,
        status,
        pxAccount,
    } = useSelector(state => state.newMigrationRedux)

    const { loadingAccounts } = useSelector(state => state.activitiesMainRedux)

    //Close window
    const closeModal = () => {
        setTab(0);
        setOpenSearch("");
        setExternalAccount(null);
        setNoSearch(false);
        setContacts(false);
        setCategories(false);
        setBehavior(false);
        setUsers(false);
        setDevices(false);
        setGeofences(false);
        setMaintenance(false);
        setDrivers(false);
        setAlerts(false);
        setInternalAccount(null);
        setServer(null);
        setNewInternalAccount(null);
        setSpeedOverrides(false);
        dispatch(clearRedux("IMPORT_P4"));
    }
    //Obtain PX accounts
    const getAccountsForSelect = (input, callback) => {
        if (!input) {
            callback([])
            return
        }
        getAccounts(input).then((response) => {
            if (response.result) {
                const { items } = response?.result
                callback(items)
            }
        })
    }

    //Start a new migration
    const importAccounts = () => {
        let entities = ["accounts"]

        //Validation of entities
        if (contacts) entities.push("contacts")
        if (categories) entities.push("categories")
        if (behavior) entities.push("behavior")
        if (users) entities.push("users")
        if (devices) entities.push("devices")
        if (geofences) entities.push("geofences")
        if (maintenance) entities.push("maintenance_tasks")
        if (drivers) entities.push("drivers")
        if (alerts) entities.push("alerts")
        if (speedOverrides) entities.push("road_speed_overrides")

        let payload = {
            sourcePlatform: server.id,
            externalCompanyId: externalAccount.id,
            entities,
        }

        if (internalAccount?.id && status !== "MigrationNotExists") {
            payload.pairWithCompanyId = internalAccount.id
        }

        dispatch(accountsImportRequest(payload))

    }

    useEffect(() => {
        if (status && (status === "MigrationNotExists" || status === "MigrationNotExists_AccountNameExists")) {
            dispatch(accountsGetAccountByPxRequest(externalAccount.name))
        }
    }, [status])

    useEffect(() => {
        if (pxAccount) {
            setInternalAccount(pxAccount);
            setNewInternalAccount(pxAccount);
            dispatch(clearRedux("IMPORT_P4", { pxAccount: null }))
        }
        if (result) {
            if (result?.stepFunctionId) {
                NotificationManager.success(
                    messages['new_migration_success_message'],
                    messages['new_migration_import_from_p4'],
                    3000
                );
                getData();
                closeModal();
            }
            if (result?.error) {
                console.error(result.error)
                let message = messages["new_migration_error_message"]
                if (result?.error?.error) {
                    if (messages[result.error.error])
                        message = messages[result.data.error.error]
                    else
                        message = result.error.error.replace("Bad request ->", "").replace("GraphQL error: ", "")
                }
                NotificationManager.error(
                    message,
                    messages['new_migration_import_from_p4'],
                    3000
                );
            }
            dispatch(clearRedux("IMPORT_P4", { result: null }))
        }
    }, [pxAccount, result])

    let validateStatus = status === "MigrationNotExists" && externalAccount?.name && internalAccount?.name && internalAccount?.name !== externalAccount?.name

    return (
        <Modal
            open={openModal}
            title={`${messages['new_migration_import_from_p4']} ${externalAccount ? `(${externalAccount.name})` : ''}`}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <Tabs
                    tab={+tab}
                    disabled={true}
                >
                    <TabContainer disabled={true} index={0} label={messages['new_migration_account']}>
                        <div style={{ marginTop: 10, marginBottom: 40 }}>
                            <Form
                                ref={formRef}
                                onValidSubmit={() => {
                                    if (!noSearch) {
                                        dispatch(accountsImportSearchAccountRequest({
                                            openSearch,
                                            sourcePlatform: server?.id
                                        }))
                                    }
                                }}
                            >
                                <Select
                                    id="select-server"
                                    value={server}
                                    options={[
                                        {
                                            id: "InTouchStaging",
                                            name: "InTouch Staging"
                                        },
                                        {
                                            id: "InTouchAlpha",
                                            name: "InTouch Alpha"
                                        },
                                        {
                                            id: "InTouchBeta",
                                            name: "InTouch Beta"
                                        },
                                        {
                                            id: "InTouchGamma",
                                            name: "InTouch Gamma"
                                        }
                                    ]}
                                    label={messages['new_migration_server']}
                                    required
                                    requiredMessage={messages['required_field']}
                                    onChange={setServer}
                                    loading={false}
                                    valueField="id"
                                    textField="name"
                                    placeholder={messages['select']}
                                />
                                <div style={{ marginTop: 5 }}>
                                    <FormControl style={{ width: '100%' }}>
                                        <label className="input-normal-label">{messages['new_migration_account_name']}<span className="text-danger"> *</span></label>
                                        <OutlinedInput
                                            style={{ marginTop: 2, height: 42, fontSize: 'inherit', color: '#212529' }}
                                            className={`imports-search-accounts ${noSearch ? 'imports-search-accounts-error' : ''}`}
                                            disabled={false}
                                            id="custom-search"
                                            placeholder={messages['new_migration_account_name']}
                                            type="text"
                                            value={openSearch || ''}
                                            fullWidth={true}
                                            onChange={(event) => {
                                                setNoSearch(false);
                                                setOpenSearch(event.target.value)
                                            }}
                                            required
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <div style={{
                                                        height: 40,
                                                        width: 34,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        cursor: 'pointer'
                                                    }}
                                                        onClick={() => {
                                                            if (!openSearch) setNoSearch(true)
                                                            else setNoSearch(false)
                                                            formRef.current?.submit();
                                                        }}
                                                    >
                                                        <Icon>search</Icon>
                                                    </div>
                                                </InputAdornment>
                                            }
                                        />
                                        {noSearch && <small className="select-error text-danger">{messages['required_field']}</small>}
                                    </FormControl>
                                </div>
                                <label className="input-normal-label" style={{ marginTop: 8 }}>{messages['new_migration_records_found']}</label>
                                <div style={{
                                    width: '100%',
                                    marginTop: 10,
                                    boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
                                    borderRadius: 5,
                                    maxHeight: 300,
                                    overflowX: 'auto'
                                }}>
                                    {
                                        accountsList.length ? (
                                            <ul style={{ margin: 0, padding: 5 }}>
                                                {
                                                    accountsList.map((item, key) => {
                                                        return (
                                                            <li
                                                                key={key}
                                                                style={{
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center',
                                                                    height: 40,
                                                                    cursor: 'pointer',
                                                                    backgroundColor: externalAccount?.id === item?.id && '#ccc',
                                                                    borderRadius: 5,
                                                                    padding: 5
                                                                }}
                                                                onClick={() => setExternalAccount(item)}
                                                            >
                                                                {`${item.id} - ${item.name}`}
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        ) : (
                                            <div style={{
                                                display: 'flex',
                                                height: 30,
                                                width: '100%',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                color: '#212529',
                                                opacity: 0.6
                                            }}>
                                                {messages['new_migration_no_data_available']}
                                            </div>
                                        )
                                    }

                                </div>
                            </Form>
                        </div>
                    </TabContainer>
                    <TabContainer disabled={true} index={1} label={messages['new_migration_entities']}>
                        <div style={{ marginTop: 10 }}>
                            {
                                status && (
                                    <Alert
                                        style={{ marginBottom: 5 }}
                                        severity="info"
                                    >
                                        {
                                            status === "MigrationNotExists"
                                                && externalAccount?.name && newInternalAccount?.name === externalAccount?.name
                                                ? <AlertTitle>{messages[status] || status}</AlertTitle> : <></>
                                        }
                                        { //MigrationNotExists_AccountNameExists
                                            status === "MigrationNotExists_AccountNameExists"
                                                && externalAccount?.name && newInternalAccount?.name === externalAccount?.name
                                                ? <AlertTitle>{messages[status] || status}</AlertTitle> : <></>
                                        }
                                        {
                                            status === "MigrationExists" ? messages[status] : <></>
                                        }
                                        {
                                            status === "MigrationNotExists"
                                                && externalAccount?.name && newInternalAccount?.name !== externalAccount?.name
                                                ? messages[status] || status : <></>
                                        }
                                        {externalAccount?.name && newInternalAccount?.name === externalAccount?.name &&
                                            `${messages['new_migration_account_registered']} ${externalAccount.name} ${messages['new_migration_in_px']}`
                                        }
                                    </Alert>
                                )
                            }
                        </div>
                        {
                            (status === "MigrationNotExists" || status === "MigrationNotExists_AccountNameExists") && (
                                <div>
                                    <CustomSelect
                                        async
                                        value={internalAccount}
                                        onChange={setInternalAccount}
                                        label={messages['new_migration_pair_with_this_px']}
                                        loadOptions={getAccountsForSelect}
                                        loading={loadingAccounts}
                                        getOptionLabel={e => `${e.id} - ${e.name}`}
                                        getOptionValue={e => e.id}
                                    />
                                    {
                                        validateStatus &&
                                        <Alert
                                            style={{ marginTop: 5 }}
                                            severity="warning"
                                        >
                                            {messages['new_migration_verify_accounts']}
                                        </Alert>
                                    }
                                </div>
                            )
                        }
                        <div style={{ marginTop: 10 }}>
                            <label className="input-normal-label">{messages['new_migration_entity_to_migrate']}</label>
                            <div style={{ width: '100%', display: 'grid', marginBottom: 30 }}>
                                <Checkbox
                                    label={messages['new_migration_account']}
                                    className="itemCheck mb-0"
                                    type="checkbox"
                                    id="account-check"
                                    value={accounts}
                                    onChange={() => setAccounts(true)}
                                />
                                <Checkbox
                                    label={messages['new_migration_contacts']}
                                    className="itemCheck mb-0"
                                    type="checkbox"
                                    id="contacts-check"
                                    value={contacts}
                                    onChange={setContacts}
                                />
                                <Checkbox
                                    label={messages['new_migration_categories']}
                                    className="itemCheck mb-0"
                                    type="checkbox"
                                    id="categories-check"
                                    value={categories}
                                    onChange={setCategories}
                                />
                                <Checkbox
                                    label={messages['new_migration_behavior']}
                                    className="itemCheck mb-0"
                                    type="checkbox"
                                    id="behavior-check"
                                    value={behavior}
                                    onChange={setBehavior}
                                />
                                <Checkbox
                                    label={messages['new_migration_users']}
                                    className="itemCheck mb-0"
                                    type="checkbox"
                                    id="users-check"
                                    value={users}
                                    onChange={setUsers}
                                />
                                <Checkbox
                                    label={messages['new_migration_drivers']}
                                    type="checkbox"
                                    id="drivers-check"
                                    value={drivers}
                                    onChange={setDrivers}
                                />
                                <Checkbox
                                    label={messages['new_migration_devices']}
                                    type="checkbox"
                                    id="devices-check"
                                    value={devices}
                                    onChange={setDevices}
                                />
                                <Checkbox
                                    label={messages['new_migration_geofences']}
                                    type="checkbox"
                                    id="geofences-check"
                                    value={geofences}
                                    onChange={setGeofences}
                                />
                                <Checkbox
                                    label={messages['new_migration_alerts']}
                                    type="checkbox"
                                    id="alerts-check"
                                    value={alerts}
                                    onChange={setAlerts}
                                />
                                <Checkbox
                                    label={messages['new_migration_maintenance']}
                                    type="checkbox"
                                    id="maintenance-check"
                                    value={maintenance}
                                    onChange={setMaintenance}
                                />
                                <Checkbox
                                    label={messages['new_migration_speed_override']}
                                    type="checkbox"
                                    id="speed-override-check"
                                    value={speedOverrides}
                                    onChange={setSpeedOverrides}
                                />
                            </div>
                        </div>
                    </TabContainer>
                </Tabs>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => {
                        if (tab === 1) {
                            setContacts(false);
                            setCategories(false);
                            setBehavior(false);
                            setUsers(false);
                            setDevices(false);
                            setGeofences(false);
                            setMaintenance(false);
                            setDrivers(false);
                            setTab(tab - 1);
                            setInternalAccount(null);
                            setSpeedOverrides(false);
                        } else closeModal()
                    }}
                >
                    {tab === 1 ? messages['common_back'] : messages['close']}
                </Button>
                <Button
                    disabled={externalAccount === null || ((status === "MigrationNotExists" || status === "MigrationNotExists_AccountNameExists") && validateStatus)}
                    className="btn-dark-blue"
                    onClick={() => {
                        if (tab === 0) {
                            dispatch(accountsGetStatusRequest({
                                externalCompanyId: externalAccount?.id,
                                sourcePlatform: server?.id
                            }))
                            setTab(tab + 1)
                        } else importAccounts()
                    }}
                >
                    {tab === 1 ? messages['new_migration_import'] : messages['common_next']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}
export default NewMigration